import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d105c036"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "submitting-overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isSubmitting)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : _createCommentVNode("", true)
}